module.exports = "<nav>\r\n    <ul>\r\n        <li *ngFor=\"let item of menuService.items\">\r\n            <fw-menu-item [item]=\"item\">\r\n            </fw-menu-item>\r\n        </li>\r\n    </ul>\r\n</nav>";


//////////////////
// WEBPACK FOOTER
// ./Scripts/fw/menu/menu.component.html
// module id = 2128
// module chunks = 1